module.exports = __webpack_public_path__ + "img/layout-sidebar-reverse.8e4aa0fa.svg";